import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import Pagination from "react-js-pagination";
import pagiarray from 'paginate-array';
import Filter from '../util/Filter';
import Description from '@material-ui/icons/Description';
import { format } from 'date-fns';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
    DatePicker, Space, Table, Row, Col, Modal, Button, Input,
    Select, Tooltip
} from 'antd';
import "antd/dist/antd.css";
import moment from 'moment';
import { CSVLink } from 'react-csv';
import {
    DeleteOutlined, EditOutlined, PlusCircleOutlined,
    ExclamationCircleOutlined, BellOutlined
} from '@ant-design/icons';
import pr from '../util/pr';
import GetApiHost from '../util/GetApiHost';
const { Option } = Select;
const { confirm } = Modal;

const Message = styled.div`
    border:1px solid #cccccc;
    width:600px;
    padding: 5px;
    margin-top:10px;
    color:blue;
`;

const TableContainer = styled.div`
    margin-top:30px;
    width:400px;
`

const Add = styled.div`    
    margin-bottom:10px;
`;

export default function Setup() {
    const [teacher, setTeacher] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    const [modalVisible, setModalVisible] = useState(false);
    const api_host = GetApiHost();
    const [centers, setCenters] = useState([]);
    const [cid, setCid] = useState("");
    let result;
    const [rows, setRows] = useState([]);
    const [mode, setMode] = useState('');
    const [inputName, setInputName] = useState('');
    const [inputPhone, setInputPhone] = useState('');
    const [seq, setSeq] = useState(0);
    const token = localStorage.getItem('refresh_token');
    const [login, setLogin] = useState({});

    const handle_center_change = value => {
        setCid(value);
    }

    // 센터코드 바뀌면 리스트 갱신
    useEffect(() => {
        get_list();
    }, [cid]);

    // 센터목록 셀랙트 박스
    const CenterSelect = () => {
        return (
            <Select style={{ width: 200, textAlign: "left" }} defaultValue="" onChange={value => handle_center_change(value)} value={cid}>
                <Option value="">지점선택</Option>
                { centers.map((n, i) => {
                    return (<Option key={i} value={n.value}>{n.label}</Option>);
                })}
            </Select>);
    }

    const getCenterList = async () => {
        let rows = [];
        result = await axios.post(data.url + "/slim/center_list", {
            sid: 'smartgym'
        });
        result.data.map((n, i) => {
            rows.push({
                value: n.cid,
                label: n.center + ' ' + n.location
            })
        });
        setCenters(rows);
    }

    const login_check = async () => {
        result = await LoginCheck(data.url);
        if (result === "Y") {
            const decodeResult = await DecodeData(data.url);
            dispatch({ type: 'SET', name: "CID", value: decodeResult.cid });
            dispatch({ type: 'SET', name: "LEVEL", value: decodeResult.level });
            setLogin(
                state => {
                    return { ...state, level: decodeResult.level }
                }
            )

            if (decodeResult.level < 500) { // 최고관리자가 아니면 cid 선택불가
                setCid(decodeResult.cid);
            }
            else {
                setCid('CT14S15143839.Pdfg3');
            }

        } else {
            LoginFail();
        }
    }

    const add_form = () => {
        setMode('add');
        setInputName('');
        setInputPhone('');
        setModalVisible(true);
    }

    const columns = [
        {
            dataIndex: 'name',
            key: 'name',
            title: '이름',
        },
        {
            dataIndex: 'phone',
            key: 'phone',
            title: '연락처',
        },
        {
            dataIndex: 'act',
            key: 'act',
            title: '',
            align: 'center',
        }
    ];

    const get_list = async () => {
        result = await axios.post(api_host + '/sp/get_sms_phone', { token: token, cid: cid });
        let state = [];
        result.data.map((n, i) => {
            state.push({
                key: i,
                name: n.name,
                phone: n.phone,
                act: <>
                    <Tooltip placement="top" title="알림 테스트!!!">
                        <Button icon={<BellOutlined />} onClick={() => sms_post(n.phone)} />
                    </Tooltip>
                    <Tooltip placement="top" title="수정">
                        <Button icon={<EditOutlined />} style={{ marginLeft: 5 }} onClick={() => edit_form(n.seq, n.name, n.phone)} />
                    </Tooltip>
                    <Tooltip placement="top" title="삭제">
                        <Button icon={<DeleteOutlined />} style={{ marginLeft: 5 }} onClick={() => delete_post(n.seq)} />
                    </Tooltip>
                </>
            });
        });
        setRows(state);
    }

    useEffect(() => {  // START HERE!     
        login_check();
        getCenterList();
        get_list();
    }, []);

    const add_post = async () => {
        const name = inputName;
        const phone = inputPhone;
        result = await axios.post(api_host + '/sp/add_sms_phone', {
            cid: cid,
            phone: phone,
            name: name,
            mode: mode,
            seq: seq
        });
        if (result.data.ret === 'N') {
            alert(result.data.msg);
        }
        else {
            setModalVisible(false);
            get_list();
        }
    }

    const edit_form = (seq, name, phone) => {
        setSeq(seq);
        setInputName(name);
        setInputPhone(phone);
        setMode('edit');
        setModalVisible(true);
    }

    const delete_post = (seq) => {
        confirm({
            icon: <ExclamationCircleOutlined />,
            content: '삭제하시겠습니까?',
            onOk() {
                axios.post(api_host + '/sp/del_sms_phone', { seq: seq })
                    .then(() => get_list())
                    .catch(e => { });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const sms_post = async (phone) => {
        const data = {
            cid: cid,
            phone: phone,
            title: '알림',
            message: '알림 발송 테스트!!!'
        }
        result = await axios.post(api_host + '/push/to_phone', data);    
        Modal.success({
            content: '푸시발송 완료',
        });
    }

    const push_to_manager = async () => {
        // let { token, cid, title, message } = req.body;
        result = await axios.post(api_host + '/push/to_manager',{
            token:token,
            cid:cid,
            title:'알림',
            message:'알림 발송 테스트!!!'
        });
        Modal.success({
            content: '푸시발송 완료',
        });
    }

    return (
        <main className="main-container">

            <TopNav />
            <div className="content-wrapper">
                <MainNav />

                <div className="content-inner">

                    <Modal title="연락처 등록/수정"
                        // onOk={}
                        onCancel={() => { setModalVisible(false) }}
                        visible={modalVisible}
                        footer={[]}
                    >
                        <div>
                            <Row>
                                <Col style={{ width: '20%' }}>이름</Col>
                                <Col space={{ width: '80%' }}><Input name="name" value={inputName} onChange={e => setInputName(e.currentTarget.value)}></Input></Col>
                            </Row>
                            <Row style={{ marginTop: 5 }}>
                                <Col style={{ width: '20%' }}>연락처</Col>
                                <Col space={{ width: '80%' }}><Input name="phone" placeholder="000-0000-0000" value={inputPhone} onChange={e => setInputPhone(e.currentTarget.value)}></Input></Col>
                            </Row>
                            <Row style={{ marginTop: 60, justifyContent: "center" }}>
                                {mode === "add" ?
                                    <Col><Button type="primary" size="large" onClick={() => add_post()}>등록완료</Button></Col> :
                                    <Col><Button type="primary" size="large" onClick={() => add_post()}>수정완료</Button></Col>}
                            </Row>
                        </div>
                    </Modal>

                    <h3 style={{ display: "inline-block" }}>환경설정</h3>


                    <div className="content-component">
                        {login.level >= 500 ? //관리자만
                            <div style={{ textAlign: "right", width: 800 }}>
                                <CenterSelect></CenterSelect>
                            </div> : null}

                        <Row style={{ width: "800px" }}>
                            <Col>푸시알림 관리자 지정</Col>
                        </Row>
                        <Message>
                            * 지정된 담당자 앱으로 [환불신청]이 등록되면 알림을 발송합니다.
                        </Message>

                        <div className="content-body">
                            <TableContainer>
                                {cid !== "" ?
                                    <Add>
                                        <Button onClick={add_form}>등록</Button>                                        
                                        <Button style={{ marginLeft:5 }} onClick={()=>push_to_manager()}>푸시알림 TEST</Button>                                        
                                    </Add>
                                   
                                    : null}
                                <Table columns={columns} dataSource={rows} bordered>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}